export default "__VITE_ASSET__BJ0BQhb9__"